// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// AmazonPlatform Module

// This module provides support for advertising in the Client application.
// There are several different types of desktop ads supported: banners,
// verticalbanners, smallsquares, squares, leaderboards, skyscrapers,
// and interstitials.
//
// Support for throttling display rate is also provided.  For example,
// one can decide to only show an ad in the slot a certain percentage of the
// time.  This is important to be responsive to user input and maximize
// ad revenue and user satisfaction.
//
// Sample Amazon code
//
// <iframe src="//rcm-na.amazon-adsystem.com/e/cm
//    ?o=1
//    &p=11
//    &l=ez
//    &f=ifr
//    &linkID=2b143482fb7ee012f0028f4278f15324
//    &t=sizzl0e-20
//    &tracking_id=sizzl0e-20"
//    width="120"
//    height="600"
//    scrolling="no"
//    border="0"
//    marginwidth="0"
//    style="border:none;"
//    frameborder="0">
// </iframe>
//
// or
//
// <div class="alignleft">
//   <script type="text/javascript">
//           amzn_assoc_ad_type = "banner";
//    amzn_assoc_marketplace = "amazon";
//    amzn_assoc_region = "US";
//    amzn_assoc_placement = "assoc_banner_placement_default";
//    amzn_assoc_banner_type = "ez";
//    amzn_assoc_p = "11";
//    amzn_assoc_width = "120";
//    amzn_assoc_height = "600";
//    amzn_assoc_tracking_id = "sizzl0e-20";
//    amzn_assoc_linkid = "2705d616746ca2ff7f30fbd9ab79dcd2";
//   </script>
//     <script src="//z-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&Operation=GetScript&ID=OneJS&WS=1"></script>
//    </div>


define('AmazonPlatform',['require','Policies','Utilities'],function (require) {
    'use strict';

    var // Require.js module dependencies
        Policies = require('Policies'),
        Utilities = require('Utilities'),

        // Common
        policies,
        utilities,
        platformName = 'Amazon',        // Name of the ad platform in use
        initialized,                    // True if ad platform was initialized
        bannerRate = 1.0,               // How frequently to show banner ads
        interstitialRate = 0.3,         // How frequently to show interstitials
        linkId,                         // Publisher ID for advertising affiliate
        trackingId,                     // Tracking Id for advertising affiliate
        adSlots,                        // Advertising credentials

        // Other
        main,
        adDiv;


    // Constructor
    function AmazonPlatform () {

        // Dependent resources
        policies = new Policies();
        utilities = new Utilities();


        // Public Methods

        // Set Tracking ID
        this.setTrackingId = function () {
            trackingId = policies.getPolicy('amazonTrackingId');
        };

        // Get random Ad Slot from available slots
        this.getRandomAdSlot = function (adSlots) {
            return adSlots[Math.floor(Math.random()*adSlots.length)];
        };

        // Set Ad Slots
        this.setAdSlots = function () {
            // Credentials
            adSlots = {
                banner: {
                    adTrackingId:       trackingId,
                    adSlots:            [
                                            '?o=1&p=288&l=ur1&category=gift_certificates&banner=' +
                                                policies.getPolicy('amazonBannerGiftCertificateBannerAdSlot') +
                                                '&f=ifr&linkID=' + policies.getPolicy('amazonBanner1AdSlot'),
                                            '?o=1&p=288&l=ur1&category=amazonhomepage&f=ifr&linkID=' +
                                                policies.getPolicy('amazonBanner2AdSlot')
                                        ],
                    displayRate:        bannerRate,
                    width:              '320px',
                    height:             '50px',
                    adReady:            false,
                    isAdShowing:        false
                },
                verticalbanner1: {
                    adTrackingId:       trackingId,
                    adSlots:            [
                                            '?o=1&p=8&l=ez&f=ifr&linkID=' +
                                                policies.getPolicy('amazonVerticalbanner1AdSlot'),
                                            '?o=1&p=8&l=ez&f=ifr&linkID=' +
                                                policies.getPolicy('amazonVerticalbanner2AdSlot')
                                        ],
                    displayRate:        bannerRate,
                    width:              '120px',
                    height:             '240px',
                    adReady:            false,
                    isAdShowing:        false
                },
                verticalbanner2: {
                    adTrackingId:       trackingId,
                    adSlots:            [
                                            '?o=1&p=8&l=ez&f=ifr&linkID=' +
                                                policies.getPolicy('amazonVerticalbanner1AdSlot'),
                                            '?o=1&p=8&l=ez&f=ifr&linkID=' +
                                                policies.getPolicy('amazonVerticalbanner2AdSlot')
                                        ],
                    displayRate:        bannerRate,
                    width:              '120px',
                    height:             '240px',
                    adReady:            false,
                    isAdShowing:        false
                },
                leaderboard: {
                    adTrackingId:       trackingId,
                    adSlots:            [
                                            '?o=1&p=48&l=ur1&category=gift_certificates&banner=' +
                                                policies.getPolicy('amazonLeaderboardGiftCertificateBannerAdSlot') +
                                                '&f=ifr&linkID=' + policies.getPolicy('amazonLeaderboard1AdSlot'),
                                            '?o=1&p=48&l=ur1&category=mp3&f=ifr&linkID=' +
                                                policies.getPolicy('amazonLeaderboard2AdSlot'),
                                            '?o=1&p=48&l=ur1&category=electronics&f=ifr&linkID=' +
                                                policies.getPolicy('amazonLeaderboard3AdSlot'),
                                            '?o=1&p=48&l=ur1&category=amazonhomepage&f=ifr&linkID=' +
                                                policies.getPolicy('amazonLeaderboard4AdSlot'),
                                            '?o=1&p=48&l=ur1&category=kindlerotating&f=ifr&linkID=' +
                                                policies.getPolicy('amazonLeaderboard5AdSlot'),
                                            '?o=1&p=48&l=ur1&category=musicandentertainmentrot&f=ifr&linkID=' +
                                                policies.getPolicy('amazonLeaderboard2AdSlot'),
                                            '?o=1&p=48&l=ur1&category=dominoprojectbooks&f=ifr&linkID=' +
                                                policies.getPolicy('amazonLeaderboard2AdSlot')
                                        ],
                    displayRate:        bannerRate,
                    width:              '728px',
                    height:             '90px',
                    adReady:            false,
                    isAdShowing:        false
                },
                smallsquare: {
                    adClient:           policies.getPolicy('amazonSmallsquareAdSlot'),
                    adTrackingId:       trackingId,
                    displayRate:        bannerRate,
                    width:              '200px',
                    height:             '200px',
                    adReady:            false,
                    isAdShowing:        false
                },
                square: {
                    adClient:           policies.getPolicy('amazonSquareAdSlot'),
                    adTrackingId:       trackingId,
                    displayRate:        bannerRate,
                    width:              '250px',
                    height:             '250px',
                    adReady:            false,
                    isAdShowing:        false
                },
                skyscraper: {
                    adClient:           policies.getPolicy('amazonSkyscraperAdSlot'),
                    adTrackingId:       trackingId,
                    adSlots:            [
                                            '?o=1&p=14&l=ur1&category=gift_certificates&banner=' +
                                                policies.getPolicy('amazonSkyscraperGiftCertificateBannerAdSlot') +
                                                '&f=ifr&linkID=' + policies.getPolicy('amazonSkyscraper1AdSlot'),
                                            '?o=1&p=14&l=ur1&category=mp3&f=ifr&linkID=' +
                                                policies.getPolicy('amazonSkyscraper2AdSlot'),
                                            '?o=1&p=14&l=ur1&category=electronics&f=ifr&linkID=' +
                                                policies.getPolicy('amazonSkyscraper3AdSlot'),
                                            '?o=1&p=14&l=ur1&category=amazonhomepage&f=ifr&linkID=' +
                                                policies.getPolicy('amazonSkyscraper4AdSlot'),
                                            '?o=1&p=14&l=ur1&category=kindlerotating&f=ifr&linkID=' +
                                                policies.getPolicy('amazonSkyscraper5AdSlot'),
                                            '?o=1&p=14&l=ur1&category=musicandentertainmentrot&f=ifr&linkID=' +
                                                policies.getPolicy('amazonSkyscraper6AdSlot'),
                                            '?o=1&p=14&l=ur1&category=dominoprojectbooks&f=ifr&linkID=' +
                                                policies.getPolicy('amazonSkyscraper7AdSlot')
                                        ],
                    displayRate:        bannerRate,
                    width:              '160px',
                    height:             '600px',
                    adReady:            false,
                    isAdShowing:        false
                }
            };
        };

        // Set the display rate for banner ads
        this.setAdSlotDisplayRate = function (newBannerRate) {
            // Desktop rates
            adSlots.banner.displayRate          = bannerRate;
            adSlots.verticalbanner1.displayRate = bannerRate;
            adSlots.verticalbanner2.displayRate = bannerRate;
            adSlots.square.displayRate          = bannerRate;
            adSlots.smallsquare.displayRate     = bannerRate;
            adSlots.leaderboard.displayRate     = bannerRate;
            adSlots.skyscraper.displayRate      = bannerRate;
        };

        // Set the display rate for interstitial ads
        this.setInterstitialDisplayRate = function (newInterstitialRate) {
            // Unsupported for now
        };

        // Set ad display Rates based on policies
        this.setDisplayRates = function () {
            // Ad Slots
            var newBannerRate = policies.getPolicy('adDisplayRateBanner');
            if (newBannerRate) {
                this.setAdSlotDisplayRate(parseFloat(newBannerRate));
            }
            // Interstitials
            var newInterstitialRate =
                    policies.getPolicy('adDisplayRateInterstitial');
            if (newInterstitialRate) {
                this.setInterstitialDisplayRate(parseFloat(newInterstitialRate));
            }
        };
    };

    // Public Prototype Methods

    // Initializations
    AmazonPlatform.prototype.initialize = function (newMain) {
        // Save reference to Main.js
        main = newMain;

        // Set advertising credentials from Server policies
        this.setTrackingId();
        this.setAdSlots();

        // Set display rates from Server policies
        this.setDisplayRates();

        // Set initial state
        initialized = true;
    };

    // Show ad in specified element
    AmazonPlatform.prototype.showAd = function (
        visible, type, parentDiv, callback) {

        // Remove any previous ad
        while (parentDiv.firstChild) {
            parentDiv.removeChild(parentDiv.firstChild);
        }

        // Construct and show new ad if requested
        if (visible && !adSlots[type].isAdShowing) {

            // Setup iFrame
            var iFrame = document.createElement('iframe');
            iFrame.setAttribute('src',
                '//rcm-na.amazon-adsystem.com/e/cm' +
                this.getRandomAdSlot(adSlots[type].adSlots) +
                '&t=' + trackingId +
                '&tracking_id=' + trackingId
            );

            // Inline style iFrame
            iFrame.setAttribute('width', '' + parseInt(adSlots[type].width, 10));
            iFrame.setAttribute('height', '' + parseInt(adSlots[type].height, 10));
            iFrame.setAttribute('scrolling', 'no');
            iFrame.setAttribute('border', '0');
            iFrame.setAttribute('marginwidth', '0');
            iFrame.setAttribute('style', 'border:none;');
            iFrame.setAttribute('frameborder', '0');

            // Create the ad div
            adDiv = document.createElement('div');
            adDiv.style.width = adSlots[type].width;
            adDiv.style.height = adSlots[type].height;

            // Parent should be full size, just in case
            parentDiv.style.width = adDiv.style.width;
            parentDiv.style.height = adDiv.style.height;

            // Assemble
            adDiv.appendChild(iFrame);
            parentDiv.appendChild(adDiv);
        }

        // Show or hide
        parentDiv.style.display = (visible ? 'inline-block' : 'none');

        // Record that ad is currently [not] showing
        adSlots[type].isAdShowing = visible;

        // Notify listeners if any
        if (callback) {
            callback();
        }
    };

    // Show small banner ad
    AmazonPlatform.prototype.showBannerAd = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'banner', parentDiv, callback);
    };

    // Show verticalbanner1 ad
    AmazonPlatform.prototype.showVerticalbanner1Ad = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'verticalbanner1', parentDiv, callback);
    };

    // Show verticalbanner2 ad
    AmazonPlatform.prototype.showVerticalbanner2Ad = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'verticalbanner2', parentDiv, callback);
    };

    // Show leaderboard ad
    AmazonPlatform.prototype.showLeaderboardAd = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'leaderboard', parentDiv, callback);
    };

    // Show small square ad
    AmazonPlatform.prototype.showSmallSquareAd = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'smallsquare', parentDiv, callback);
    };

    // Show square ad
    AmazonPlatform.prototype.showSquareAd = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'square', parentDiv, callback);
    };

    // Show skyscraper ad
    AmazonPlatform.prototype.showSkyscraperAd = function (
        visible, parentDiv, callback) {
        this.showAd(visible, 'skyscraper', parentDiv, callback);
    };

    // Get Ad platform name
    AmazonPlatform.prototype.getAdPlatform = function () {
        return platformName;
    };

    // Return Constructor
    return AmazonPlatform.prototype.constructor;
});

